import {
  Image as MantineImage,
  ImageProps as MantineImageProps,
} from '@mantine/core'

type CustomImageProps = MantineImageProps & {
  alt: string
}

export const Image = ({ alt, ...props }: CustomImageProps) => (
  <MantineImage
    fallbackSrc='https://placehold.co/600x400?text=Placeholder'
    alt={alt}
    {...props}
  />
)
